<template>
  <div id="designated">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
export default {
  name: 'designated'
}
</script>




// WEBPACK FOOTER //
// src/views/exhibition/booth/designated/Designated.vue